<template>
    <div
        :class="[
            'inline-flex font-bold items-center px-4 py-2 border cursor-pointer rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200',
            {
                'text-white bg-gradient-to-tr from-primary to-secondary transition-all duration-200':
                    backgroundPrimary,
            },
            {
                'text-primary bg-white hover:text-primary border-primary hover:border-primary':
                    backgroundWhite,
            },
            {
                'opacity-60 transition-all duration-75': disabled,
            },
        ]"
    >
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        backgroundPrimary: {
            type: Boolean,
        },
        backgroundWhite: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
        },
    },
};
</script>
